import React, { Component } from "react";
import PropTypes from "prop-types";
import onClickOutside from "react-onclickoutside";

class SubMenuCards extends Component {
  constructor(props) {
    super(props);
    // bind our methods
    this.closeMenu = this.closeMenu.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  /**
   * Triggers the Menu to be closed
   */
  closeMenu() {
    this.props.hideMenuHandler();
  }

  handleClickOutside(event) {
    this.closeMenu();
  }

  render() {
    const { sub, title, cards } = this.props.item;
    return cards ? (
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1 bg-white bg-sm-none shadow-lg px-0">
          <div className="px-md-2 pt-md-2 bg-white w-100 mx-0">
            <div className="d-flex justify-content-between p-2 p-sm-1 p-md-0">
              <i
                className="ml-auto fa text-align-right fa-times-circle text-primary"
                style={{ cursor: "pointer", fontSize: "1.5rem" }}
                onClick={this.closeMenu}
              />
            </div>
            <div className="row no-gutters gutters-sm align-items-stretch px-4 mb-4 mb-sm-0">
              {cards.map((card, index) => {
                const {
                  title = false,
                  description = false,
                  tagline = false,
                  link = false,
                  thumbnail,
                  buttonText = "Unit Plan",
                } = card;
                return (
                  <div key={index} className="col-12 col-sm-6 col-lg-4 pb-0">
                    <div className="card h-100 rounded-0 border-0">
                      {!thumbnail ? null : (
                        <img
                          src={thumbnail}
                          className="d-none rounded-top d-sm-block img-fluid"
                        />
                      )}
                      <div className="card-body p-3 d-flex flex-sm-column justify-content-between align-items-center align-items-sm-stretch text-sm-center text-md-left border rounded-bottom mb-sm-4">
                        <div className="pr-2 pr-sm-0">
                          <h4 className="paragraph">
                            <strong>
                              {!title ? null : (
                                <span className="text-primary h5-sm h4-md">
                                  {title}{" "}
                                </span>
                              )}
                              <br />
                              {!title ? null : `${description} `}
                            </strong>
                            <br />
                          </h4>
                          {!tagline ? null : (
                            <p className="paragraph-small pt-1 pt-sm-4 mb-0 mb-sm-4">
                              {tagline}
                            </p>
                          )}
                        </div>
                        {!link ? null : (
                          <a
                            className="btn btn-primary p-sm-1 rounded"
                            href={link}
                          >
                            {!buttonText ? "Read More" : buttonText}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }
}

/**
 * Defines the shape of data sent through for a "Card style" sub menu
 */
export const CardItemProps = PropTypes.shape({
  title: PropTypes.string,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      tagline: PropTypes.string,
      body: PropTypes.string,
      link: PropTypes.string,
      buttonText: PropTypes.string,
    })
  ),
});

SubMenuCards.propTypes = {
  item: CardItemProps,
  hideMenuHandler: PropTypes.func.isRequired,
};

SubMenuCards.defaultProps = {
  hideMenuHandler: () => {
    console.log("hideMenuHandler for SubMenuCards is not set, please fix");
  },
};

export default onClickOutside(SubMenuCards);



// WEBPACK FOOTER //
// ./resources/assets/js/app/MegaMenu/SubMenuCards.js